import { cmxDateTime, commonEnums } from '@codametrix/ui-common';

const { FieldType } = commonEnums;

const DateOfService: CMxCommonApp.TextField = {
  key: 'date_of_service',
  path: ['date_of_service'],
  displayName: null,
  classNames: [['invoice-meta-text-heading']],
  readonly: true,
  width: '1fr',
  fieldType: FieldType.Text,
  datetimeFormat: cmxDateTime.FORMATS.DATE_OF_SERVICE,
  fallbackValue: 'Date not selected'
};

const DepartmentField: CMxCommonApp.TextField = {
  key: 'department',
  path: ['department', 'name'],
  displayName: 'Department',
  classNames: [['invoice-meta-text-body']],
  readonly: true,
  width: '1fr',
  fieldType: FieldType.Text
};

const PeformingNameField: CMxCommonApp.TextField = {
  key: 'performing_provider_name',
  path: ['performing_provider_name'],
  appendValuePath: ['performing_provider_number', 'number'],
  displayName: 'Performed By',
  classNames: [['invoice-meta-text-body']],
  readonly: true,
  width: '1fr',
  fieldType: FieldType.Text
};

const ProviderNameField: CMxCommonApp.TextField = {
  key: 'billing_provider_name',
  path: ['billing_provider_name'],
  appendValuePath: ['billing_provider_number', 'number'],
  displayName: 'Billing provider',
  classNames: [['invoice-meta-text-body']],
  readonly: true,
  width: '1fr',
  fieldType: FieldType.Text
};

const ReferredByField: CMxCommonApp.TextField = {
  key: 'referred_by',
  path: ['referring_provider_name'],
  appendValuePath: ['referring_provider_number', 'number'],
  displayName: 'Referred By',
  classNames: [['invoice-meta-text-body']],
  readonly: true,
  width: '1fr',
  fieldType: FieldType.Text
};

// These are the current form fields for the invoice metadata form in both the grade bench and code bench panel
// If these fields need to change dynamicaly then InvoiceMetadataFormFields can be added to the redux state rather than statically defined here
export const InvoiceMetadataFormFields = [
  DateOfService,
  DepartmentField,
  PeformingNameField,
  ProviderNameField,
  ReferredByField
];

export const InvoiceMetadataFormFieldsCQA = [
  { ...DateOfService, path: ['dateOfService'] },
  { ...DepartmentField },
  { ...PeformingNameField, path: ['performingProviderName'] },
  { ...ProviderNameField, path: ['billingProviderName'] },
  { ...ReferredByField, path: ['referringProviderName'] }
];
